import React from "react";
import { TextField } from "@mui/material";

const CustomTextfields = ({
  label,
  value,
  handleChange,
  name,
  error,
  helperText,
  required,
  disabled,
  validation,
  maxLength,
  InputProps,
  ...rest
}) => {
  const handleInputChange = (event) => {
    let val = event.target.value;

    // numeric validation
    if (validation === "numeric") {
      val = val.replace(/[^0-9]/g, "");
    }

    // maxLength validation
    if (maxLength) {
      val = val.slice(0, maxLength);
    }

    handleChange({
      target: {
        name,
        value: val,
      },
    });
  };

  return (
    <TextField
      fullWidth
      label={label}
      name={name}
      value={value}
      onChange={handleInputChange}
      error={Boolean(error)}
      helperText={error || helperText}
      required={required}
      disabled={disabled}
      InputProps={InputProps}
      margin="normal"
      {...rest}
    />
  );
};

export default CustomTextfields;
